import { Injectable, EventEmitter } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { Config } from '../app.config';
import { SpecName, Flow } from './models/spec-name.model';
import { uniq } from 'lodash';

@Injectable()
export class AutomationService {

    private serviceAPIUrl: string = null;

    private stubsServiceAPIUrl: string = null;

    private mainMergedRecords = null;

    public fileData = null;

    public identifiersPerService = null;

    public registerSpinner: Subject<boolean> = new Subject<boolean>();

    public password: string = '';

    constructor(private http: Http, private _config: Config) {

        this.serviceAPIUrl = `${_config.baseUrl}/v1/automation`;

        this.stubsServiceAPIUrl = `${_config.baseUrl}/v1/stubs`;
    }

  loadRpmData() {

       let headers = new Headers({ 'Content-Type': 'application/json' });

        let options = new RequestOptions({ headers: headers, withCredentials: true });

        let services: string[] = [];

        return this.http.get(this.serviceAPIUrl + '/rpm/domain', options)
            .map((response: any) => {
                return response.json();
        });
  }
    listSpecNames(): Observable<{
        specNames: SpecName[],
        services: string[]
    }> {

        let headers = new Headers({ 'Content-Type': 'application/json' });

        let options = new RequestOptions({ headers: headers, withCredentials: true });

        let services: string[] = [];

        return this.http.get(this.serviceAPIUrl + '/services-spec-names', options)
            .map((response: any) => {

                const specNames: SpecName[] = response.json();

                if (specNames && specNames.length) {

                    specNames.forEach((specName: SpecName) => {

                        services = services.concat(Object.keys(specName.flows));
                    });
                }

                return {
                    specNames,
                    services: uniq(services)
                }
            });
    }

    listAutomationProcesses(): Observable<any[]> {

        let headers = new Headers({ 'Content-Type': 'application/json' });

        let options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.get(this.serviceAPIUrl + '/automation-processes', options)
            .map((response: any) => {

                return response.json();
            });
    }

    removeAutomationProccess(proccessId: string): Observable<any> {

        let headers = new Headers({ 'Content-Type': 'application/json' });

        let options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.delete(this.serviceAPIUrl + `/automation-processes/${proccessId}`, options)
            .map((response: any) => {

                return response.json();
            });
    }

    validateTdrsSheet(fileToUpload: File) {

        const formData: FormData = new FormData();

        let headers = new Headers();

        headers.set('enctype', 'multipart/form-data');

        const options = new RequestOptions({ headers, withCredentials: true });

        formData.append('file', fileToUpload, fileToUpload.name);

        return this.http
            .post(this.serviceAPIUrl + '/validate-tdrs-sheet', formData, options)
            .map((response: any) => {

                response = response.json();

                if (response && response.checksData && response.checksData.length) {

                    return this.mapCheckedIdentifiers(response);
                }
                return [];
            })
            .catch((error) => Observable.throw(error));

    }

    mapCheckedIdentifiers(response) {

        return response.checksData.map((item) => ({
            serviceName: item.serviceName,
            stubs: item.result.map((result) => {

                const identifiers = [];

                for (let identiferName in result.identifiers) {

                    identifiers.push({
                        name: identiferName,
                        value: result.identifiers[identiferName]
                    });
                }

                return {
                    _id: result._id,
                    stubName: (result.stubName.length > 80) ? result.stubName.slice(0, 160) + ' ...' : result.stubName,
                    identifiers: identifiers
                }
            })
        }));
    }

    generateAutomationProccess(fileToUpload: File) {

        const formData: FormData = new FormData();

        let headers = new Headers();

        headers.set('enctype', 'multipart/form-data');

        const options = new RequestOptions({ headers, withCredentials: true });

        formData.append('file', fileToUpload, fileToUpload.name);

        return this.http
            .post(this.serviceAPIUrl + '/start-automation-process', formData, options)
            .map((response: any) => {

                response = response.json();

                const mergedRecords = response.mergedRecords;

                this.mainMergedRecords = response.mainMergedRecords;

                const oldValuesForStubs = {};

                const defaultStubsPerRecord = {};

                const allRecords: string[] = [];

                for (let recordName in mergedRecords) {

                    allRecords.push(recordName.toUpperCase());

                    defaultStubsPerRecord[recordName] = [];

                    for (let serviceName in mergedRecords[recordName]) {

                        let defaultStub: any = {};

                        if (mergedRecords[recordName][serviceName].defaultStub) {

                            defaultStub = mergedRecords[recordName][serviceName].defaultStub;
                        } else {

                            defaultStub = {
                                name: 'AUTOMATED || DEFAULT_STUB',
                                respCode: 200
                            };
                        }

                        oldValuesForStubs[recordName + serviceName] = {
                            stubName: defaultStub.name,
                            respCode: defaultStub.respCode
                        };

                        defaultStubsPerRecord[recordName].push({
                            serviceName,
                            stubName: defaultStub.name,
                            oldStubName: defaultStub.name,
                            respCode: defaultStub.respCode
                        })
                    }
                }

                return {
                    defaultStubsPerRecord,
                    allRecords,
                    oldValuesForStubs,
                    defaultStubsStatus: response.defaultStubsStatus,
                    automationProccesId: response.automationProccesId
                };
            })
            .catch((error) => Observable.throw(error));
    }

    generateTDRS(data) {

        let headers = new Headers();

        const options = new RequestOptions({ headers, withCredentials: true });

        const defaultStubsPerRecord = {};

        for (let recordName in data.defaultStubsPerRecord) {

            defaultStubsPerRecord[recordName] = {};

            data.defaultStubsPerRecord[recordName]
                .forEach((recordValue) => {

                    defaultStubsPerRecord[recordName][recordValue.serviceName] = {
                        defaultStub: {
                            stubName: recordValue.stubName.trim(),
                            respCode: recordValue.respCode
                        }
                    }
                });
        }

        return this.http
            .put(this.serviceAPIUrl + '/generate-tdrs', {
                defaultStubsStatus: data.defaultStubsStatus,
                automationProccesId: data.automationProccesId,
                defaultStubsPerRecord: defaultStubsPerRecord,
                mainMergedRecords: this.mainMergedRecords,
                fileData: this.fileData
            }, options)
            .map((response) => response)
            .catch((error) => Observable.throw(error));

    }


    addServiceSpecName(specNameDetails): Observable<any> {

        let headers = new Headers();

        const options = new RequestOptions({ headers, withCredentials: true });

        let mappedSpecName = this.constructSpecName(specNameDetails);

        return this.http
            .post(this.serviceAPIUrl + '/services-spec-names', mappedSpecName, options)
            .map((response) => response)
            .catch((error) => Observable.throw(error));
    }

    constructSpecName(specNameDetails): SpecName {

        const flows: Flow | any = {};

        specNameDetails.flows.forEach(flow => {

            flows[flow.serviceName] = {
                isActive: flow.isActive,
                isMain: flow.isMain,
                defaultStub: (flow.defaultStub) ? {
                    name: flow.defaultStub.name.trim(),
                    respCode: Number(flow.defaultStub.respCode)
                } : null,
                jsonPaths: flow.jsonPaths ?
                    flow.jsonPaths.map((jsonpath) => {

                        if (jsonpath.path) {

                            jsonpath.path = jsonpath.path.trim();
                        }

                        if (jsonpath.propName) {

                            jsonpath.propName = jsonpath.propName.trim();
                        }

                        if (jsonpath.identifierJsonPath) {

                            jsonpath.identifierJsonPath = jsonpath.identifierJsonPath.trim();
                        }

                        if (jsonpath.identifierType) {

                            jsonpath.identifierType = jsonpath.identifierType.trim();
                        }

                        return jsonpath;
                    }) : undefined
            };
        });

        return {
            name: specNameDetails.name.trim(),
            type: specNameDetails.type,
            flows
        };
    }
    removeSpecName(specNameId: string): Observable<any> {

        let headers = new Headers({ 'Content-Type': 'application/json' });

        headers.set('password', this.password);

        let options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.delete(this.serviceAPIUrl + `/services-spec-names/${specNameId}`, options)
            .map((response: any) => {

                return response.json();
            });
    }


    findSpecName(specNameId: string): Observable<SpecName> {

        let headers = new Headers({ 'Content-Type': 'application/json' });

        let options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.get(this.serviceAPIUrl + `/services-spec-names/${specNameId}`, options)
            .map((response: any) => {

                return response.json()[0];
            });
    }

    updateSpecName(specNameId, specNameDetails) {

        let headers = new Headers({ 'Content-Type': 'application/json' });

        let options = new RequestOptions({ headers: headers, withCredentials: true });

        const specNameChanges = this.detectChangesInSpecName(specNameDetails);

        return this.http.put(this.serviceAPIUrl + `/services-spec-names/${specNameId}`, specNameChanges, options)
            .map((response: any) => {

                return response.json();
            });
    }

    public getStubByName(servcieName: string, stubName: string, respCode: string) {

        let headers = new Headers({ 'Content-Type': 'application/json' });

        let options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.get(this.serviceAPIUrl + `/getStubByName/${servcieName}/${stubName}/${respCode}`, options)
            .map((response: any) => {

                return response.json();
            });
    }

    detectChangesInSpecName(specNameDetails) {

        const flows: Flow | any = {};

        specNameDetails.changes.forEach((change, index) => {

            let mappedFlow = null;

            if (change.flow) {

                mappedFlow = {
                    isActive: change.flow.isActive,
                    isMain: change.flow.isMain,
                    defaultStub: (change.flow.defaultStub) ? {
                        name: change.flow.defaultStub.name.trim(),
                        respCode: Number(change.flow.defaultStub.respCode)
                        } : null,
                    jsonPaths: change.flow.jsonPaths ?
                        change.flow.jsonPaths.map((jsonpath) => {
                                jsonpath.path = jsonpath.path.trim();
                                jsonpath.propName = jsonpath.propName.trim();
                                jsonpath.identifierJsonPath = jsonpath.identifierJsonPath ? jsonpath.identifierJsonPath.trim() : undefined;
                                return jsonpath;
                            }) : undefined
                    };
            }

            specNameDetails.changes[index].flow = mappedFlow ? mappedFlow : undefined;
        });

        return {
            name: specNameDetails.name.trim(),
            type: specNameDetails.type,
            changes: specNameDetails.changes
        };
    }

    public generateArrayFromObj(flow) {
        return Object.keys(flow).map((key) => {
            flow[key].servcieName = key;
            return flow[key];
        });
    }

    public listExcelSheetsExamples() {

        let headers = new Headers({ 'Content-Type': 'application/json' });

        let options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.get(this.serviceAPIUrl + `/excel`, options)
            .map((response: any) => {

                return response.json();
            });
    }

    public addExcelSheetAsExample(fileToUpload: File) {

        const formData: FormData = new FormData();

        let headers = new Headers();

        headers.set('enctype', 'multipart/form-data');

        headers.set('password', this.password);

        const options = new RequestOptions({ headers, withCredentials: true });

        formData.append('file', fileToUpload, fileToUpload.name);

        return this.http.post(this.serviceAPIUrl + `/excel`, formData, options)
            .map((response: any) => {

                return response;
            }).catch((error) => {

                return Observable.throw(error);
            });
    }

    public removeExcelSheet(fileName: string) {

        let headers = new Headers({ 'Content-Type': 'application/json' });

        headers.set('file', fileName);

        headers.set('password', this.password);

        let options = new RequestOptions({
            headers: headers,
            withCredentials: true
        });

        return this.http.delete(this.serviceAPIUrl + `/excel`, options)
            .map(() => {

                return null;
            });
    }

    public downloadExcelSheet(fileName: string) {

        let headers = new Headers({});

        headers.set('file', fileName);

        let options = new RequestOptions({
            headers: headers,
            withCredentials: true
        });

        return this.http.get(this.serviceAPIUrl + `/excel/download`, options)
            .map((response: any) => {

                this.download(response._body, fileName.split('.')[0]);

                return null;
            });
    }

    public removeRolledBackProcesses() {

        let headers = new Headers({ 'Content-Type': 'application/json' });

        headers.set('password', this.password);

        let options = new RequestOptions({
            headers: headers,
            withCredentials: true
        });

        return this.http.delete(this.serviceAPIUrl + `/automation-processes/rolled-back-proccess`, options)
            .map((response: any) => {

                return response && response.json ? response.json() : null;
            });
    }

    public download(data, filename) {

        const blob = new Blob([this.s2ab(atob(data))], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const a = document.createElement("a");

        const url = URL.createObjectURL(blob);

        a.href = url;

        a.download = filename;

        document.body.appendChild(a);

        a.click();

        setTimeout(function () {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }, 0);
    }

    public s2ab(s) {

        var buf = new ArrayBuffer(s.length);

        var view = new Uint8Array(buf);

        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;

        return buf;
    }

    public pretifyJson(json): string {
        if (typeof json != 'string') {
            json = JSON.stringify(json, undefined, 2);
        }
        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            var cls = 'number';
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = 'key';
                } else {
                    cls = 'string';
                }
            } else if (/true|false/.test(match)) {
                cls = 'boolean';
            } else if (/null/.test(match)) {
                cls = 'null';
            }

            let color = '';

            if (cls === 'key') {

                color = 'red';
            } else if (cls === 'number') {

                color = 'darkorange';
            } else if (cls === 'boolean') {

                color = 'blue';
            } else if (cls === 'string') {

                color = 'green';
            } else if (cls === 'null') {

                color = 'magenta';
            } else {

                color = 'black';
            }
            return `<span style="color:${color};" class="'${cls}'">${match}</span>`;
        });
    }

    public async copyToClipboard(textToCopy) {
        // Navigator clipboard api needs a secure context (https)
        if ((<any>navigator).clipboard && window.isSecureContext) {
            await (<any>navigator).clipboard.writeText(textToCopy);
        } else {
            // Use the 'out of viewport hidden text area' trick
            const textArea = document.createElement("textarea");
            textArea.value = textToCopy;

            // Move textarea out of the viewport so it's not visible
            textArea.style.position = "absolute";
            textArea.style.left = "-999999px";

            (<any>document.body).prepend(textArea);
            textArea.select();

            try {
                document.execCommand('copy');
            } catch (error) {
                console.error(error);
            } finally {
                textArea.remove();
            }
        }
    }


    TransformJSON(nilJSON): Observable<any> {

        let headers = new Headers({ 'Content-Type': 'application/json' });

        let options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.post(this.serviceAPIUrl + '/transform-json', nilJSON, options)
            .map((response: any) => {

                return response.json()
            }).catch((error) => {

                return Observable.throw(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/automation/automation.service.ts